import '../types';
import bangleCodeTemplate from './bangleCodeTemplate';
import '../stores/types';
export function genCode(guiCreatorData) {
    const functionCodes = createFunctionCodes(guiCreatorData);
    const renderMap = createRenderMap(guiCreatorData);
    let generatedCode = bangleCodeTemplate.toString();
    const globalFunctions = convertGlobalFunctionToCode(functionCodes.globalFunctions);
    generatedCode = generatedCode.replace('const globalFunctions = {};', 'const globalFunctions = ' + globalFunctions);
    generatedCode = generatedCode.replace('const uiObjects = {};', functionCodes.codeString);
    generatedCode = generatedCode.replace('this.pageSettings = {};', convertPageSettingsToCode(guiCreatorData));
    generatedCode = generatedCode.replace('this.renderMap = {};', 'this.renderMap = ' + JSON.stringify(renderMap, null, 2));
    return generatedCode;
}
function areSquaresOverlapping(rect1, rect2) {
    return rect1.tl.x < rect2.br.x && rect1.br.x > rect2.tl.x && rect1.tl.y < rect2.br.y && rect1.br.y > rect2.tl.y;
}
function createRenderMap(guiCreatorData) {
    const renderMap = {};
    Object.keys(guiCreatorData.pages).forEach(pageKey => {
        renderMap[pageKey] = {};
        const currentPage = guiCreatorData.pages[pageKey];
        Object.keys(currentPage.elements).forEach(elementKey => {
            const elementRenderBox = currentPage.elements[elementKey].getRenderBox();
            const overlappingElements = Object.keys(currentPage.elements).filter((key) => {
                if (key === elementKey) {
                    return false;
                }
                const otherElementRenderBox = currentPage.elements[key].getRenderBox();
                return areSquaresOverlapping(elementRenderBox, otherElementRenderBox) && currentPage.elements[key].z > currentPage.elements[elementKey].z;
            }).map(key => ({
                name: currentPage.elements[key].name,
                z: currentPage.elements[key].z,
            }));
            overlappingElements.sort((a, b) => a.z - b.z);
            renderMap[pageKey][currentPage.elements[elementKey].name] = overlappingElements;
        });
    });
    return renderMap;
}
function convertPageSettingsToCode(guiCreatorData) {
    let generatedPageSettingsCode = 'this.pageSettings = {';
    Object.keys(guiCreatorData.pages).forEach(pageKey => {
        const currentPage = guiCreatorData.pages[pageKey];
        const pageSetting = {
            swipeable: currentPage.swipeable,
        };
        generatedPageSettingsCode += '\n\t "' + pageKey + '": ' + JSON.stringify(pageSetting, null, 2) + ',';
    });
    generatedPageSettingsCode += '\n}';
    return generatedPageSettingsCode;
}
function convertGlobalFunctionToCode(functions) {
    let codeString = '{';
    Object.keys(functions).forEach(functionKey => {
        codeString += `${functionKey}: `;
        Object.keys(functions[functionKey]).forEach((functionChar) => {
            codeString += functions[functionKey][functionChar];
        });
        codeString += ',\n';
    });
    codeString += '};';
    return codeString;
}
function convertUIGenCodeObjToCode(uiGenCode) {
    let codeString = '{';
    Object.keys(uiGenCode).forEach(k => {
        codeString += '\n    ' + k + ': ' + (typeof uiGenCode[k] === 'string' ? `"${uiGenCode[k]}"` : uiGenCode[k]) + ',';
    });
    codeString += '\n}';
    return codeString;
}
function getFunction(argumentCount, replacementFunctionName) {
    let args = [];
    for (let i = 0; i < argumentCount; i++) {
        args.push(String.fromCharCode(97 + i));
    }
    let functionCodeString;
    if (argumentCount === 0) {
        functionCodeString = `globalFunctions['${replacementFunctionName}'].call(this);`;
    }
    else {
        functionCodeString = `return globalFunctions['${replacementFunctionName}'].bind(this)(${args.join(',')});`;
    }
    args.push(functionCodeString);
    return new Function(...args);
}
function compressMethod(convertedCode, attributeName, globalFunctions) {
    let replacementFunctionName = Object.keys(globalFunctions).find((key) => globalFunctions[key] === convertedCode[attributeName].toString());
    if (!replacementFunctionName) {
        replacementFunctionName = attributeName[0] + Object.keys(globalFunctions).length;
        globalFunctions[replacementFunctionName] = convertedCode[attributeName].toString();
    }
    if (attributeName === 'onScreenTouch') {
        convertedCode[attributeName] = getFunction(1, replacementFunctionName);
    }
    else if (attributeName === 'wasTouched') {
        convertedCode[attributeName] = getFunction(1, replacementFunctionName);
    }
    else if (attributeName === 'moveElement') {
        convertedCode[attributeName] = getFunction(2, replacementFunctionName);
    }
    else if (attributeName === 'onDrag') {
        convertedCode[attributeName] = getFunction(1, replacementFunctionName);
    }
    else {
        convertedCode[attributeName] = getFunction(0, replacementFunctionName);
    }
    return convertedCode;
}
function createFunctionCodes(guiCreatorData) {
    const convertedCodes = {};
    Object.keys(guiCreatorData.pages).forEach(pageKey => {
        convertedCodes[pageKey] = Object.keys(guiCreatorData.pages[pageKey].elements).map(elementKey => {
            return guiCreatorData.pages[pageKey].elements[elementKey].convertToCode();
        });
    });
    const globalFunctions = {};
    Object.keys(convertedCodes).forEach(pageKey => {
        convertedCodes[pageKey] = convertedCodes[pageKey].map(convertedCode => {
            convertedCode = compressMethod(convertedCode, 'render', globalFunctions);
            if (convertedCode.onScreenTouch) {
                convertedCode = compressMethod(convertedCode, 'onScreenTouch', globalFunctions);
            }
            if (convertedCode.moveElement) {
                convertedCode = compressMethod(convertedCode, 'moveElement', globalFunctions);
            }
            if (convertedCode.wasTouched) {
                convertedCode = compressMethod(convertedCode, 'wasTouched', globalFunctions);
            }
            if (convertedCode.onDrag) {
                convertedCode = compressMethod(convertedCode, 'onDrag', globalFunctions);
            }
            return convertedCode;
        });
    });
    const codeStrings = {};
    Object.keys(convertedCodes).forEach(pageKey => {
        codeStrings[pageKey] = Object.keys(convertedCodes[pageKey]).map(elementKey => convertUIGenCodeObjToCode(convertedCodes[pageKey][elementKey]));
    });
    let uiObjectCode = 'const uiObjects = {\n';
    Object.keys(codeStrings).forEach(pageKey => {
        uiObjectCode += `'${pageKey}': [\n`;
        codeStrings[pageKey].forEach(elementCode => uiObjectCode += `${elementCode},\n`);
        uiObjectCode += `],\n`;
    });
    uiObjectCode += '}';
    return { codeString: uiObjectCode, globalFunctions: globalFunctions };
}
